import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from "@/components/login";
import Home from "@/components/home";
import NotFound from "@/components/NotFound";
import index from "@/components/index.vue";
import laundrymanage from '../components/laundrymanage.vue'
import cleanermanage from '../components/cleanermanage.vue'
import inspectionmanage from '../components/inspectionmanage.vue'
import Schoolmanage from '../components/schoolmanage.vue'
import SchoolManagerManage from '../components/schoolmanager.vue'

Vue.use(VueRouter)

const routes = [
  { path: '*', name: 'NotFound', component: NotFound },
  { path: '/', redirect: '/index' },
  { path: '/login', component: Login },
  {
    path: '/home', component: Home, redirect: '/index', children: [
      { path: '/index', component: index },
      { path: '/laundrymanage', component: laundrymanage },
      { path: '/cleanermanage', component: cleanermanage },
      { path: '/inspectionmanage', component: inspectionmanage },
      { path: '/Schoolmanage', component: Schoolmanage },
      { path: '/schoolmanagermanage', component: SchoolManagerManage }
    ]
  },

]

const router = new VueRouter({
  routes
})

// 挂载路由导航守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') next()
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})

export default router
